<template>
     <div  class="publicViewClass">
        <div class="show_container">
            <div class="staff_manage_head">
                     <div class="top_mange flex align-cen">
                       <div class="search_box">
                     <el-input placeholder="登录账号" v-model="search" clearable> </el-input>
                </div>
                 <div class="public-btn-small flex align-cen" style="padding-left:20px">
                    <div class="public-btn-small-primary"  @click="getApplog">搜索</div>
                    <div class="public-btn-small-text" @click="reset">重置筛选条件</div>
                </div>
                </div>
                <div class="bottom_mange">
              <div class="staff_search flex align-cen">
                <div class="staff_search_label">登录应用：</div>
                <div class="search_box1">
                      <el-select
                        v-model="value"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.appName"
                        :value="item.appName"
                        v-if="item.appName !='Herosim'"
                        >
                        </el-option>
                    </el-select>
                </div>
               </div>
                   <div class="staff_search flex align-cen">
                 <div class="staff_search_label">登录时间：</div>
                   <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions2"
                    @change="classSelect"
                    >
                    </el-date-picker>
               </div>
                </div>
            </div>
            <div class="staff_manage_center">
                 <div class="businessList-container-table">
                                   <el-table
                ref="multipleTable"
                :data="itemList"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                >
                  <el-table-column prop="username" label="登录账号" align="center">
                 </el-table-column>
                   <el-table-column prop="appName" label="登录应用" align="center">
                             </el-table-column>
                              <el-table-column  label="所属企业" align="center">
                                    <template slot-scope="scope">
                                  <div>
                                    {{scope.row.businessName || '暂无'}}
                                  </div>
                                    </template>
                             </el-table-column>
                               <el-table-column prop="loginTime" label="登录时间" align="center">
                             </el-table-column>
                              <el-table-column  label="退出时间" align="center">
                                <template slot-scope="scope">
                                  <div>
                                    {{scope.row.logoutTime ? scope.row.logoutTime : '暂无'}}
                                  </div>
                                </template>
                             </el-table-column>
                              <el-table-column  label="登录终端机器码" align="center">
                                <template slot-scope="scope">
                                  <div>
                                    {{scope.row.machineCode ? scope.row.machineCode : '暂无'}}
                                  </div>
                                </template>
                             </el-table-column>
                              <el-table-column prop="remoteAddr" label="登录IP" align="center">
                             </el-table-column>
                </el-table>
                <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                 </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getappGl,appLog} from "@/api/enterprise/index"; // 控制中心基础信息、应用日志
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
     components:{
      paginaTion
    },
    data() {
        return {
            itemList:[],
            search:'',
            options:[],
            value:'',
            value1:'',
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
         start_time:'',
            end_time:'',
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            }
    },
    created () {
         this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getappAllList()
        this.getApplog()
    },
    methods: {
        // 重置
        reset(){
            this.value = ''
            this.search = ''
            this.start_time = ''
            this.end_time = ''
            this.value1 = ''
            this.currentPage = 1
            this.getApplog()
        },
                // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getApplog()
      },
               classSelect(){
            if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }
            else{
                this.start_time=""
                this.end_time = ""
            }
            this.currentPage = 1
            this.getApplog()
         },
        // 获取应用日志
           getApplog(){
             let params = {
                businessId:this.businessInfo.id,
                username:this.search,
                appName:this.value,
                startTime:this.start_time || '',
                endTime:this.end_time || '',
                size:this.PageSize,
                current:this.currentPage,
            }
            appLog(params,'enterprise')
        .then(res =>{
            console.log(res)
            this.itemList = res.data.records
            this.totalCount = res.data.total
        })
        .catch(err =>{})
        },
         getappAllList(){
            getappGl({businessId:this.businessInfo.id},'enterprise').then(res => {
                this.options = res.data
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.staff_manage_head{
    height: 200px !important;
    line-height: none !important;
    padding: 20px 40px 0 40px !important;
}
.tagbq{
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
    display: inline-block;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #409eff;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-right: 10px;
}
::v-deep{
    .setdia{
        .setdia-check{
            padding: 0 50px;
            .el-checkbox{
                display: block;
                padding-bottom: 10px;
            }
        }
        .setdia-con{
            padding-bottom: 50px;
            .label{
                width: 160px;
            }
            .classItem{
                .el-tag{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .setbtn{
                width: 135px;
               background: #155bd4;
                   height: 32px;
                line-height: 30px;
                font-size: 14px;
                padding: 0 20px;
                border-radius: 2px;
                font-family: inherit;
                border-width: 1px;
                border-style: solid;
                text-align: center;
                vertical-align: middle;
                box-sizing: border-box;
                cursor: pointer;
                transition: all 0.3s;
                background: #155bd4;
                color: #fff;
            }
        }
        .nodyna{
            text-align: center;
            p{padding: 20px 0;}
             .setbtn{
               background: #155bd4;
                   height: 32px;
                line-height: 30px;
                font-size: 14px;
                padding: 0 20px;
                border-radius: 2px;
                font-family: inherit;
                border-width: 1px;
                border-style: solid;
                text-align: center;
                vertical-align: middle;
                box-sizing: border-box;
                cursor: pointer;
                transition: all 0.3s;
                background: #155bd4;
                color: #fff;
                margin: 0 auto;
                margin-bottom: 20px;
                width: 100px;
            }
        }
    }
      .jiange{
      padding-bottom: 20px;
      padding-right: 20px;
    }
    .el-table__body{

        td{
           padding: 5px 0;
        }
    }
    }
</style>